// JSON-LD for the `proposal_back` surface — a user's back of a market
// proposal (a stake-and-share moment, similar to `pnl_position`).

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildProposalBackJsonLd(
  _surface: Extract<ShareSurface, { kind: 'proposal_back' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const headline = ctx.name ?? 'I backed a proposal on Morfi';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: headline,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SocialMediaPosting',
      '@id': `${ctx.pageUrl}#post`,
      headline,
      ...(ctx.description !== undefined ? { articleBody: ctx.description } : {}),
      url: ctx.pageUrl,
      image: ctx.ogImageUrl,
      publisher: { '@id': organizationId() },
    },
  ];
}
